import utils from 'utils'
class modalPageCtrl {
    constructor($scope, $timeout, $filter, $uibModalInstance, logger, globalFn, httpRequest, items1) {
        $scope.modaldata = items1[0]
        const dictTypeArr = ['auth_code_grant_state', 'department_no', 'yes_no_flag', 'apply_type', 'drawer_channel_type', 'register_type', 'belle_register_type']
        httpRequest.get_dictByTypeArr(JSON.stringify(dictTypeArr)).then((res1) => {
            $scope.dictData = res1.data.value
        })
        $scope.selectChange = function () {
            setTimeout(() => {
                $('.regDate').datetimepicker({
                    autoclose: true,
                    minView: 'month', // 选择日期后，不会再跳转去选择时分秒
                    language: 'zh-CN',
                    format: 'yyyy-mm-dd',
                    forceParse: 0,
                    pickTime: false,
                    pickerPosition: 'bottom-right',
                })
            }, 200)
        }
        $scope.selectChange()
        $scope.authCodeDateChange = (authCodeDate) => {
            $scope.authCodeDate = authCodeDate
            const { registerType } = $scope.modaldata
            const control = {
                0: {
                    mapper() {
                        let originalAuthCodeDate = new Date(authCodeDate);
                        //加上90天
                        let newDate = new Date(originalAuthCodeDate);
                        newDate.setDate(originalAuthCodeDate.getDate() + 90);
                        // let newDate = new Date(originalAuthCodeDate.getTime() + (90 * 24 * 60 * 60 * 1000));
                        $scope.authCodeVaildDate = dateHandler(newDate)

                    },
                },
                12: {
                    mapper() {
                        $scope.authCodeVaildDate = new Date(authCodeDate);
                        $scope.authCodeVaildDate.setFullYear($scope.authCodeVaildDate.getFullYear() + 1);
                        $scope.authCodeVaildDate = dateHandler($scope.authCodeVaildDate)
                    },
                },
            };
            control[registerType].mapper();
        }
        function dateHandler(date) {
            let originalDate = new Date(date);
            let year = originalDate.getFullYear().toString(); // 获取年份的最后两位
            let month = (originalDate.getMonth() + 1).toString().padStart(2, '0'); // 月份需要加1，且不足两位时补0
            let day = originalDate.getDate().toString().padStart(2, '0'); // 日不足两位时补0
            let formattedDate = year + '-' + month + '-' + day;
            return formattedDate
        }
        // 关闭
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }
        // 确定
        $scope.ok = function (v) {
            let updateList = items1.map(el => {
                return {
                    registerId: el.registerId,
                    authCodeDate: $scope.authCodeDate || '',
                    authCodeGrantState: $scope.modaldata.authCodeGrantState,
                    authCodeVaildDate: $scope.authCodeVaildDate || '',
                    registerType: $scope.modaldata.registerType,
                }
            });
            console.log(`output->`, updateList)
            httpRequest.post_batchUpdate(updateList, '更新成功').then((res) => {
                $uibModalInstance.close($scope.modaldata)
            })
        }
    }
}

modalPageCtrl.$inject = ['$scope', '$timeout', '$filter', '$uibModalInstance', 'logger', 'globalFn', 'httpRequest', 'items1']
export default modalPageCtrl


// WEBPACK FOOTER //
// ./src/app/system/permission/registrationCodeManagement/modalPageCtrl.js